export default "__VITE_ASSET__CRGWoj5w__"